module.exports = __webpack_public_path__ + "img/1522886486.21d26cf9.jpg";